var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeneral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1319 13.3559C15.5943 14.8128 14.7813 16.0796 13.7152 17.1207C12.5017 18.3057 10.9126 19.2473 8.99216 19.919C8.92914 19.9409 8.86337 19.959 8.7973 19.9722C8.71002 19.9895 8.62121 19.9988 8.53317 20H8.51593C8.42209 20 8.32779 19.9905 8.23425 19.9722C8.16818 19.959 8.10333 19.9409 8.04062 19.9194C6.11786 19.2488 4.52682 18.3076 3.31207 17.1227C2.24548 16.0815 1.43264 14.8155 0.895838 13.3586C-0.0802668 10.7097 -0.0247248 7.79159 0.0199835 5.44662L0.0207464 5.41061C0.0297491 5.21697 0.0355474 5.01357 0.0387518 4.78896C0.0550787 3.68621 0.931849 2.77389 2.03475 2.71239C4.33426 2.58407 6.11313 1.8341 7.63305 0.35262L7.64633 0.340413C7.89871 0.108937 8.2167 -0.00458834 8.53317 0.00014191C8.83835 0.00410921 9.1423 0.117482 9.38568 0.340413L9.39865 0.35262C10.9189 1.8341 12.6978 2.58407 14.9973 2.71239C16.1002 2.77389 16.9769 3.68621 16.9933 4.78896C16.9965 5.0151 17.0023 5.21819 17.0113 5.41061L17.0117 5.42587C17.0563 7.77526 17.1115 10.6992 16.1319 13.3559Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6505 8.0478L12.6504 8.04788L8.13225 12.5667L8.13224 12.5667L7.15595 13.543C6.95462 13.7443 6.6908 13.8448 6.42668 13.8448C6.1623 13.8448 5.89873 13.7443 5.69704 13.5429L3.59804 11.443L3.59802 11.443C3.19534 11.0403 3.19529 10.388 3.59806 9.985L3.59809 9.98496C4.00012 9.5824 4.65321 9.5823 5.05594 9.98503L6.32062 11.2497L6.42668 11.3558L6.53275 11.2497L11.1925 6.58995L11.1925 6.58991C11.5953 6.18692 12.2483 6.18702 12.6503 6.58984L12.6504 6.58995C13.0532 6.99269 13.0531 7.64577 12.6505 8.0478Z",
    fill: "white",
    stroke: "#171717",
    strokeWidth: 0.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneral);
export default __webpack_public_path__ + "static/media/General.8750ac291de582ad0fe122e49baa0c71.svg";
export { ForwardRef as ReactComponent };